export let mockRemoveHouseholdMember = {
  // success: false,
  // error: "failed_refund",
  success: true,
  itemSlotsTaken: [
    {
      signupItemID: 28,
      slotsTaken: 0,
    },
    {
      signupItemID: 29,
      slotsTaken: 1,
    },
    {
      signupItemID: 30,
      slotsTaken: 0,
    },
  ],
  signupListID: 11,
  items: [
    {
      ID: 28,
      title: "Nose Bleeds",
      description: "",
      type: 1,
      totalSlots: 20,
      slotsTaken: 4,
      maxSingleUserSlots: 4,
      orderNumber: 0,
      hasSignupCost: true,
      amount: 500,
      costType: "PerSlot",
      fundName: "Signup - All New Test Event",
      respondents: [
        {
          isHousehold: true,
          householdTitle: "The User Household",
          householdID: 3,
          numberOfSlots: 2,
          householdRespondents: [],
        },
      ],
      cancelledRespondents: [
        {
          userID: 2,
          name: "Super Admin",
          fname: "Super",
          userSignupHistory: [
            {
              signupListItem: {
                ID: 28,
                title: "Nose Bleeds",
              },
              event: {
                ID: 1,
                created: {
                  timestamp: 1671653924,
                  dateString: "Dec 21 at 3:18 PM",
                  userInfo: {
                    ID: 2,
                    fname: "Super",
                    lname: "Admin",
                  },
                },
                confirmationNumber: "2KCR",
                signedUpViaIcon: "faExternalLink",
                details: {
                  slots: 1,
                  additionalNames: [
                    {
                      fname: "Super",
                      lname: "Admin",
                      isUserWhoSignedUp: true,
                    },
                  ],
                },
              },
            },
            {
              signupListItem: {
                ID: 28,
                title: "Nose Bleeds",
              },
              event: {
                ID: 1,
                created: {
                  timestamp: 1671654127,
                  dateString: "Dec 21 at 3:22 PM",
                  userInfo: {
                    ID: 2,
                    fname: "Super",
                    lname: "Admin",
                  },
                },
                confirmationNumber: "F9F6",
                signedUpViaIcon: "faExternalLink",
                details: {
                  slots: 1,
                  additionalNames: [
                    {
                      fname: "Super",
                      lname: "Admin",
                      isUserWhoSignedUp: true,
                    },
                  ],
                },
              },
            },
            {
              signupListItem: {
                ID: 28,
                title: "Nose Bleeds",
              },
              event: {
                ID: 1,
                created: {
                  timestamp: 1671654375,
                  dateString: "Dec 21 at 3:26 PM",
                  userInfo: {
                    ID: 2,
                    fname: "Super",
                    lname: "Admin",
                  },
                },
                confirmationNumber: "8XS6",
                signedUpViaIcon: "faExternalLink",
                details: {
                  slots: 1,
                  additionalNames: [
                    {
                      fname: "Super",
                      lname: "Admin",
                      isUserWhoSignedUp: true,
                    },
                  ],
                },
              },
            },
            {
              signupListItem: {
                ID: 28,
                title: "Nose Bleeds",
              },
              event: {
                ID: 4,
                created: {
                  timestamp: 1671654414,
                  dateString: "Dec 21 at 3:26 PM",
                  userInfo: {
                    ID: 2,
                    fname: "Super",
                    lname: "Admin",
                  },
                },
                confirmationNumber: "8XS6",
                signedUpViaIcon: "faExternalLink",
                details: {
                  switchedToItemID: null,
                },
              },
            },
            {
              signupListItem: {
                ID: 30,
                title: "50 Yard Line",
              },
              event: {
                ID: 1,
                created: {
                  timestamp: 1671744655,
                  dateString: "Dec 22 at 4:30 PM",
                  userInfo: {
                    ID: 2,
                    fname: "Super",
                    lname: "Admin",
                  },
                },
                confirmationNumber: "HL3Q",
                signedUpViaIcon: "faExternalLink",
                details: {
                  slots: 2,
                  additionalNames: [
                    {
                      fname: "Tink",
                      lname: "Wing",
                    },
                    {
                      fname: "Super",
                      lname: "Admin",
                      isUserWhoSignedUp: true,
                    },
                  ],
                },
              },
            },
          ],
        },
        {
          additionalNameID: 69,
          fname: "Regular",
          lname: "User",
          // paymentStatus: null,
          // paymentAmount: null,
          // paymentDate: null,
          // payerName: null,
          paymentStatus: "Paid",
          markedPaidRecorderName: null,
          paymentAmount: 2500,
          paymentDate: "2022-12-01",
          payerName: "Regular User",
          userID: 5,
          name: "Regular User",
          numberOfSlots: 2,
          userSignupHistory: [
            {
              signupListItem: {
                ID: 28,
                title: "Nose Bleeds",
              },
              event: {
                ID: 1,
                created: {
                  timestamp: 1671653287,
                  dateString: "Dec 21 at 3:08 PM",
                  userInfo: {
                    ID: 2,
                    fname: "Super",
                    lname: "Admin",
                  },
                },
                confirmationNumber: "7QHS",
                signedUpViaIcon: "faUsersMedical",
                details: {
                  slots: 1,
                  additionalNames: [
                    {
                      fname: "Regular",
                      lname: "User",
                      isUserWhoSignedUp: true,
                    },
                  ],
                },
              },
            },
          ],
          userSignupID: 33,
          householdID: 3,
        },
        {
          additionalNameID: 76,
          fname: "My",
          lname: "Guest",
          // paymentStatus: null,
          // paymentAmount: null,
          // paymentDate: null,
          // payerName: null,
          paymentAmount: 2000,
          paymentStatus: "Paid",
          paymentDate: "2022-12-15",
          payerName: "Regular User",
          markedPaidRecorderName: null,
          isAdditionalName: true,
        },
      ],
    },
    {
      ID: 29,
      title: "Club Level",
      description: "",
      type: 1,
      totalSlots: 20,
      slotsTaken: 1,
      maxSingleUserSlots: 4,
      orderNumber: 1,
      hasSignupCost: true,
      amount: 5000,
      costType: "PerSlot",
      fundName: "Signup - All New Test Event",
      respondents: [
        {
          isHousehold: true,
          householdTitle: "The User Household",
          householdID: 4,
          numberOfSlots: 1,
          householdRespondents: [
            {
              additionalNameID: 73,
              fname: "Other",
              lname: "User",
              paymentStatus: "MarkedAsPaid",
              paymentDate: "2022-12-01",
              paymentAmount: "500",
              payerName: "Regular User",
              markedPaidRecorderName: "the Cat in the Hat",
              userID: 6,
              name: "Other User",
              numberOfSlots: 1,
              userSignupHistory: [
                {
                  signupListItem: {
                    ID: 29,
                    title: "Club Level",
                  },
                  event: {
                    ID: 1,
                    created: {
                      timestamp: 1671744320,
                      dateString: "Dec 22 at 4:25 PM",
                      userInfo: {
                        ID: 2,
                        fname: "Super",
                        lname: "Admin",
                      },
                    },
                    confirmationNumber: "2358",
                    signedUpViaIcon: "faUsersMedical",
                    details: {
                      slots: 1,
                      additionalNames: [
                        {
                          fname: "Other",
                          lname: "User",
                          isUserWhoSignedUp: true,
                        },
                      ],
                    },
                  },
                },
              ],
              userSignupID: 37,
              householdID: 4,
            },
          ],
        },
      ],
      cancelledRespondents: [
        {
          userID: 2,
          name: "Super Admin",
          fname: "Super",
          userSignupHistory: [
            {
              signupListItem: {
                ID: 29,
                title: "Club Level",
              },
              event: {
                ID: 1,
                created: {
                  timestamp: 1671654051,
                  dateString: "Dec 21 at 3:20 PM",
                  userInfo: {
                    ID: 2,
                    fname: "Super",
                    lname: "Admin",
                  },
                },
                confirmationNumber: "2KCR",
                signedUpViaIcon: "faExternalLink",
                details: {
                  slots: 1,
                  additionalNames: [
                    {
                      fname: "Super",
                      lname: "Admin",
                      isUserWhoSignedUp: true,
                    },
                  ],
                },
              },
            },
            {
              signupListItem: {
                ID: 29,
                title: "Club Level",
              },
              event: {
                ID: 4,
                created: {
                  timestamp: 1671654114,
                  dateString: "Dec 21 at 3:21 PM",
                  userInfo: {
                    ID: 2,
                    fname: "Super",
                    lname: "Admin",
                  },
                },
                confirmationNumber: "QZQV",
                signedUpViaIcon: "faExternalLink",
                details: {
                  switchedToItemID: null,
                },
              },
            },
            {
              signupListItem: {
                ID: 29,
                title: "Club Level",
              },
              event: {
                ID: 1,
                created: {
                  timestamp: 1671654135,
                  dateString: "Dec 21 at 3:22 PM",
                  userInfo: {
                    ID: 2,
                    fname: "Super",
                    lname: "Admin",
                  },
                },
                confirmationNumber: "F9F6",
                signedUpViaIcon: "faExternalLink",
                details: {
                  slots: 1,
                  additionalNames: [
                    {
                      fname: "Super",
                      lname: "Admin",
                      isUserWhoSignedUp: true,
                    },
                  ],
                },
              },
            },
            {
              signupListItem: {
                ID: 29,
                title: "Club Level",
              },
              event: {
                ID: 2,
                created: {
                  timestamp: 1671654284,
                  dateString: "Dec 21 at 3:24 PM",
                  userInfo: {
                    ID: 2,
                    fname: "Super",
                    lname: "Admin",
                  },
                },
                confirmationNumber: "7SKV",
                signedUpViaIcon: "faExternalLink",
                details: {
                  slots: {
                    before: 0,
                    after: 0,
                  },
                  additionalNames: {
                    before: [],
                    after: [],
                    added: [],
                    removed: [],
                    autoDeleted: [],
                  },
                },
              },
            },
            {
              signupListItem: {
                ID: 29,
                title: "Club Level",
              },
              event: {
                ID: 4,
                created: {
                  timestamp: 1671654292,
                  dateString: "Dec 21 at 3:24 PM",
                  userInfo: {
                    ID: 2,
                    fname: "Super",
                    lname: "Admin",
                  },
                },
                confirmationNumber: "T3JI",
                signedUpViaIcon: "faExternalLink",
                details: {
                  switchedToItemID: null,
                },
              },
            },
            {
              signupListItem: {
                ID: 30,
                title: "50 Yard Line",
              },
              event: {
                ID: 1,
                created: {
                  timestamp: 1671744655,
                  dateString: "Dec 22 at 4:30 PM",
                  userInfo: {
                    ID: 2,
                    fname: "Super",
                    lname: "Admin",
                  },
                },
                confirmationNumber: "HL3Q",
                signedUpViaIcon: "faExternalLink",
                details: {
                  slots: 2,
                  additionalNames: [
                    {
                      fname: "Tink",
                      lname: "Wing",
                    },
                    {
                      fname: "Super",
                      lname: "Admin",
                      isUserWhoSignedUp: true,
                    },
                  ],
                },
              },
            },
          ],
        },
      ],
    },
    {
      ID: 30,
      title: "50 Yard Line",
      description: "",
      type: 1,
      totalSlots: 20,
      slotsTaken: 2,
      maxSingleUserSlots: 4,
      orderNumber: 2,
      hasSignupCost: false,
      amount: null,
      costType: null,
      fundName: null,
      respondents: [
        {
          isHousehold: true,
          householdTitle: "The Admin Household",
          householdID: 1,
          numberOfSlots: 2,
          householdRespondents: [
            {
              additionalNameID: 74,
              fname: "Tink",
              lname: "Wing",
              paymentStatus: null,
              markedPaidRecorderName: null,
              paymentAmount: null,
              paymentDate: null,
              payerName: null,
              isAdditionalName: true,
            },
            {
              additionalNameID: 75,
              fname: "Super",
              lname: "Admin",
              paymentStatus: null,
              markedPaidRecorderName: null,
              paymentAmount: null,
              paymentDate: null,
              payerName: null,
              userID: 2,
              name: "Super Admin",
              numberOfSlots: 2,
              userSignupHistory: [
                {
                  signupListItem: {
                    ID: 30,
                    title: "50 Yard Line",
                  },
                  event: {
                    ID: 1,
                    created: {
                      timestamp: 1671744655,
                      dateString: "Dec 22 at 4:30 PM",
                      userInfo: {
                        ID: 2,
                        fname: "Super",
                        lname: "Admin",
                      },
                    },
                    confirmationNumber: "HL3Q",
                    signedUpViaIcon: "faExternalLink",
                    details: {
                      slots: 2,
                      additionalNames: [
                        {
                          fname: "Tink",
                          lname: "Wing",
                        },
                        {
                          fname: "Super",
                          lname: "Admin",
                          isUserWhoSignedUp: true,
                        },
                      ],
                    },
                  },
                },
              ],
              userSignupID: 38,
              householdID: 1,
            },
          ],
        },
      ],
      cancelledRespondents: [],
    },
  ],
  signupList: {
    ID: 11,
    title: "Mocked Test Event",
    description: "",
    options: {
      allowMultipleItemSignups: 1,
      shared: 1,
      public: 1,
      expireDate: 0,
      sendReminderAt: 0,
      showConfetti: 1,
    },
    signupListVerbs: {
      ID: 1,
      title: "an Event",
      entity: "spot",
      entityPlural: "spots",
      actionName: "Sign Up",
      actionAsATitle: "Sign up for",
      actionNamePresentTense: "signing up",
      cancelName: "Cancel",
      howManyQuestion: "How many people are coming?",
      confirmOne: "you're in!",
      confirmMultiple: "you're in for # people!",
      cancelOne: "We've cancelled your spot for this event.",
      cancelMultiple: "We've cancelled your spots for this event.",
      status: 1,
    },
    signupListStatusID: 1,
    scheduledReminderSent: [],
    manualRemindersSent: [],
    signupListTypeID: 1,
    fund: {
      ID: 10,
      name: "Signup - All New Test Event",
      confirmationMessage: null,
    },
    blockAutomaticRefunds: true,
    signupItems: [
      {
        ID: 28,
        title: "Nose Bleeds",
        description: "",
        type: 1,
        totalSlots: 20,
        slotsTaken: 0,
        maxSingleUserSlots: 4,
        orderNumber: 0,
        hasSignupCost: true,
        amount: 500,
        costType: "PerSlot",
        fundName: "Signup - All New Test Event",
        respondents: [],
        cancelledRespondents: [
          {
            userID: 2,
            name: "Super Admin",
            fname: "Super",
            userSignupHistory: [
              {
                signupListItem: {
                  ID: 28,
                  title: "Nose Bleeds",
                },
                event: {
                  ID: 1,
                  created: {
                    timestamp: 1671653924,
                    dateString: "Dec 21 at 3:18 PM",
                    userInfo: {
                      ID: 2,
                      fname: "Super",
                      lname: "Admin",
                    },
                  },
                  confirmationNumber: "2KCR",
                  signedUpViaIcon: "faExternalLink",
                  details: {
                    slots: 1,
                    additionalNames: [
                      {
                        fname: "Super",
                        lname: "Admin",
                        isUserWhoSignedUp: true,
                      },
                    ],
                  },
                },
              },
              {
                signupListItem: {
                  ID: 28,
                  title: "Nose Bleeds",
                },
                event: {
                  ID: 1,
                  created: {
                    timestamp: 1671654127,
                    dateString: "Dec 21 at 3:22 PM",
                    userInfo: {
                      ID: 2,
                      fname: "Super",
                      lname: "Admin",
                    },
                  },
                  confirmationNumber: "F9F6",
                  signedUpViaIcon: "faExternalLink",
                  details: {
                    slots: 1,
                    additionalNames: [
                      {
                        fname: "Super",
                        lname: "Admin",
                        isUserWhoSignedUp: true,
                      },
                    ],
                  },
                },
              },
              {
                signupListItem: {
                  ID: 28,
                  title: "Nose Bleeds",
                },
                event: {
                  ID: 1,
                  created: {
                    timestamp: 1671654375,
                    dateString: "Dec 21 at 3:26 PM",
                    userInfo: {
                      ID: 2,
                      fname: "Super",
                      lname: "Admin",
                    },
                  },
                  confirmationNumber: "8XS6",
                  signedUpViaIcon: "faExternalLink",
                  details: {
                    slots: 1,
                    additionalNames: [
                      {
                        fname: "Super",
                        lname: "Admin",
                        isUserWhoSignedUp: true,
                      },
                    ],
                  },
                },
              },
              {
                signupListItem: {
                  ID: 28,
                  title: "Nose Bleeds",
                },
                event: {
                  ID: 4,
                  created: {
                    timestamp: 1671654414,
                    dateString: "Dec 21 at 3:26 PM",
                    userInfo: {
                      ID: 2,
                      fname: "Super",
                      lname: "Admin",
                    },
                  },
                  confirmationNumber: "8XS6",
                  signedUpViaIcon: "faExternalLink",
                  details: {
                    switchedToItemID: null,
                  },
                },
              },
              {
                signupListItem: {
                  ID: 30,
                  title: "50 Yard Line",
                },
                event: {
                  ID: 1,
                  created: {
                    timestamp: 1671744655,
                    dateString: "Dec 22 at 4:30 PM",
                    userInfo: {
                      ID: 2,
                      fname: "Super",
                      lname: "Admin",
                    },
                  },
                  confirmationNumber: "HL3Q",
                  signedUpViaIcon: "faExternalLink",
                  details: {
                    slots: 2,
                    additionalNames: [
                      {
                        fname: "Tink",
                        lname: "Wing",
                      },
                      {
                        fname: "Super",
                        lname: "Admin",
                        isUserWhoSignedUp: true,
                      },
                    ],
                  },
                },
              },
            ],
          },
          {
            additionalNameID: 69,
            fname: "Regular",
            lname: "User",
            // paymentStatus: null,
            // paymentAmount: null,
            // paymentDate: null,
            // payerName: null,
            paymentStatus: "Paid",
            markedPaidRecorderName: null,
            paymentAmount: 2500,
            paymentDate: "2022-12-01",
            payerName: "Regular User",
            userID: 5,
            name: "Regular User",
            numberOfSlots: 2,
            userSignupHistory: [
              {
                signupListItem: {
                  ID: 28,
                  title: "Nose Bleeds",
                },
                event: {
                  ID: 1,
                  created: {
                    timestamp: 1671653287,
                    dateString: "Dec 21 at 3:08 PM",
                    userInfo: {
                      ID: 2,
                      fname: "Super",
                      lname: "Admin",
                    },
                  },
                  confirmationNumber: "7QHS",
                  signedUpViaIcon: "faUsersMedical",
                  details: {
                    slots: 1,
                    additionalNames: [
                      {
                        fname: "Regular",
                        lname: "User",
                        isUserWhoSignedUp: true,
                      },
                    ],
                  },
                },
              },
            ],
            userSignupID: 33,
            householdID: 3,
          },
          {
            additionalNameID: 76,
            fname: "My",
            lname: "Guest",
            // paymentStatus: null,
            // paymentAmount: null,
            // paymentDate: null,
            // payerName: null,
            paymentAmount: 2000,
            paymentStatus: "Paid",
            paymentDate: "2022-12-15",
            payerName: "Regular User",
            markedPaidRecorderName: null,
            isAdditionalName: true,
          },
        ],
      },
      {
        ID: 29,
        title: "Club Level",
        description: "",
        type: 1,
        totalSlots: 20,
        slotsTaken: 1,
        maxSingleUserSlots: 4,
        orderNumber: 1,
        hasSignupCost: true,
        amount: 5000,
        costType: "PerSlot",
        fundName: "Signup - All New Test Event",
        respondents: [
          {
            isHousehold: true,
            householdTitle: "The User Household",
            householdID: 4,
            numberOfSlots: 1,
            householdRespondents: [
              {
                additionalNameID: 73,
                fname: "Other",
                lname: "User",
                paymentStatus: "MarkedAsPaid",
                paymentDate: "2022-12-01",
                paymentAmount: "500",
                payerName: "Regular User",
                markedPaidRecorderName: "the Cat in the Hat",
                userID: 6,
                name: "Other User",
                numberOfSlots: 1,
                userSignupHistory: [
                  {
                    signupListItem: {
                      ID: 29,
                      title: "Club Level",
                    },
                    event: {
                      ID: 1,
                      created: {
                        timestamp: 1671744320,
                        dateString: "Dec 22 at 4:25 PM",
                        userInfo: {
                          ID: 2,
                          fname: "Super",
                          lname: "Admin",
                        },
                      },
                      confirmationNumber: "2358",
                      signedUpViaIcon: "faUsersMedical",
                      details: {
                        slots: 1,
                        additionalNames: [
                          {
                            fname: "Other",
                            lname: "User",
                            isUserWhoSignedUp: true,
                          },
                        ],
                      },
                    },
                  },
                ],
                userSignupID: 37,
                householdID: 4,
              },
            ],
          },
        ],
        cancelledRespondents: [
          {
            userID: 2,
            name: "Super Admin",
            fname: "Super",
            userSignupHistory: [
              {
                signupListItem: {
                  ID: 29,
                  title: "Club Level",
                },
                event: {
                  ID: 1,
                  created: {
                    timestamp: 1671654051,
                    dateString: "Dec 21 at 3:20 PM",
                    userInfo: {
                      ID: 2,
                      fname: "Super",
                      lname: "Admin",
                    },
                  },
                  confirmationNumber: "2KCR",
                  signedUpViaIcon: "faExternalLink",
                  details: {
                    slots: 1,
                    additionalNames: [
                      {
                        fname: "Super",
                        lname: "Admin",
                        isUserWhoSignedUp: true,
                      },
                    ],
                  },
                },
              },
              {
                signupListItem: {
                  ID: 29,
                  title: "Club Level",
                },
                event: {
                  ID: 4,
                  created: {
                    timestamp: 1671654114,
                    dateString: "Dec 21 at 3:21 PM",
                    userInfo: {
                      ID: 2,
                      fname: "Super",
                      lname: "Admin",
                    },
                  },
                  confirmationNumber: "QZQV",
                  signedUpViaIcon: "faExternalLink",
                  details: {
                    switchedToItemID: null,
                  },
                },
              },
              {
                signupListItem: {
                  ID: 29,
                  title: "Club Level",
                },
                event: {
                  ID: 1,
                  created: {
                    timestamp: 1671654135,
                    dateString: "Dec 21 at 3:22 PM",
                    userInfo: {
                      ID: 2,
                      fname: "Super",
                      lname: "Admin",
                    },
                  },
                  confirmationNumber: "F9F6",
                  signedUpViaIcon: "faExternalLink",
                  details: {
                    slots: 1,
                    additionalNames: [
                      {
                        fname: "Super",
                        lname: "Admin",
                        isUserWhoSignedUp: true,
                      },
                    ],
                  },
                },
              },
              {
                signupListItem: {
                  ID: 29,
                  title: "Club Level",
                },
                event: {
                  ID: 2,
                  created: {
                    timestamp: 1671654284,
                    dateString: "Dec 21 at 3:24 PM",
                    userInfo: {
                      ID: 2,
                      fname: "Super",
                      lname: "Admin",
                    },
                  },
                  confirmationNumber: "7SKV",
                  signedUpViaIcon: "faExternalLink",
                  details: {
                    slots: {
                      before: 0,
                      after: 0,
                    },
                    additionalNames: {
                      before: [],
                      after: [],
                      added: [],
                      removed: [],
                      autoDeleted: [],
                    },
                  },
                },
              },
              {
                signupListItem: {
                  ID: 29,
                  title: "Club Level",
                },
                event: {
                  ID: 4,
                  created: {
                    timestamp: 1671654292,
                    dateString: "Dec 21 at 3:24 PM",
                    userInfo: {
                      ID: 2,
                      fname: "Super",
                      lname: "Admin",
                    },
                  },
                  confirmationNumber: "T3JI",
                  signedUpViaIcon: "faExternalLink",
                  details: {
                    switchedToItemID: null,
                  },
                },
              },
              {
                signupListItem: {
                  ID: 30,
                  title: "50 Yard Line",
                },
                event: {
                  ID: 1,
                  created: {
                    timestamp: 1671744655,
                    dateString: "Dec 22 at 4:30 PM",
                    userInfo: {
                      ID: 2,
                      fname: "Super",
                      lname: "Admin",
                    },
                  },
                  confirmationNumber: "HL3Q",
                  signedUpViaIcon: "faExternalLink",
                  details: {
                    slots: 2,
                    additionalNames: [
                      {
                        fname: "Tink",
                        lname: "Wing",
                      },
                      {
                        fname: "Super",
                        lname: "Admin",
                        isUserWhoSignedUp: true,
                      },
                    ],
                  },
                },
              },
            ],
          },
        ],
      },
      {
        ID: 30,
        title: "50 Yard Line",
        description: "",
        type: 1,
        totalSlots: 20,
        slotsTaken: 2,
        maxSingleUserSlots: 4,
        orderNumber: 2,
        hasSignupCost: false,
        amount: null,
        costType: null,
        fundName: null,
        respondents: [
          {
            isHousehold: true,
            householdTitle: "The Admin Household",
            householdID: 1,
            numberOfSlots: 2,
            householdRespondents: [
              {
                additionalNameID: 74,
                fname: "Tink",
                lname: "Wing",
                paymentStatus: null,
                markedPaidRecorderName: null,
                paymentAmount: null,
                paymentDate: null,
                payerName: null,
                isAdditionalName: true,
              },
              {
                additionalNameID: 75,
                fname: "Super",
                lname: "Admin",
                paymentStatus: null,
                markedPaidRecorderName: null,
                paymentAmount: null,
                paymentDate: null,
                payerName: null,
                userID: 2,
                name: "Super Admin",
                numberOfSlots: 2,
                userSignupHistory: [
                  {
                    signupListItem: {
                      ID: 30,
                      title: "50 Yard Line",
                    },
                    event: {
                      ID: 1,
                      created: {
                        timestamp: 1671744655,
                        dateString: "Dec 22 at 4:30 PM",
                        userInfo: {
                          ID: 2,
                          fname: "Super",
                          lname: "Admin",
                        },
                      },
                      confirmationNumber: "HL3Q",
                      signedUpViaIcon: "faExternalLink",
                      details: {
                        slots: 2,
                        additionalNames: [
                          {
                            fname: "Tink",
                            lname: "Wing",
                          },
                          {
                            fname: "Super",
                            lname: "Admin",
                            isUserWhoSignedUp: true,
                          },
                        ],
                      },
                    },
                  },
                ],
                userSignupID: 38,
                householdID: 1,
              },
            ],
          },
        ],
        cancelledRespondents: [],
      },
    ],
  },
  isApp: false,
  userID: 2,
};
